import { action } from 'satcheljs';
import ItemId from 'owa-service/lib/contract/ItemId';

/**
 * Action to delete a booking service from the store.
 */
let deleteService = action('DELETE_PBP_SERVICE', (itemId: ItemId) => ({
    itemId,
}));

export default deleteService;
